exports.FORM_NAME = {
  APPLY_JOB_POSTING_FORM: 'APPLY_JOB_POSTING_FORM',
  CREATE_TEAM_FORM: 'CREATE_TEAM_FORM',
  CREATE_POSTING_FORM: 'CREATE_POSTING_FORM',
  SEARCH_POSTING_FORM: 'SEARCH_POSTING_FORM',
  EDIT_BASIC_INFO_SEGMENT_FORM: 'EDIT_BASIC_INFO_SEGMENT_FORM',
  EDIT_CONTACTS_SEGMENT_FORM: 'EDIT_CONTACTS_SEGMENT_FORM',
  EDIT_CREDIT_CARD_SEGMENT_FORM: 'EDIT_CREDIT_CARD_SEGMENT_FORM',
  EDIT_FORM: 'EDIT_FORM',
  EDIT_SOCIAL_FORM: 'EDIT_SOCIAL_FORM',
  EDIT_TEAM_FORM: 'EDIT_TEAM_FORM',
  INVITE_FRIENDS_FORM: 'INVITE_FRIENDS_FORM',
  LOGIN_FORM: 'LOGIN_FORM',
  NEW_PASSWORD_FORM: 'NEW_PASSWORD_FORM',
  NEW_PROJECT_FORM: 'NEW_PROJECT_FORM',
  RESET_PASSWORD_FORM: 'RESET_PASSWORD_FORM',
  SIGNUP_FORM: 'SIGNUP_FORM',
  UPDATE_PASSWORD_FORM: 'UPDATE_PASSWORD_FORM',
  SUBMIT_PROJECT_FORM: 'SUBMIT_PROJECT_FORM',
  USER_BASIC_PROFILE_FORM: 'USER_BASIC_PROFILE_FORM',
  USER_COMPLETE_PROFILE_FORM: 'USER_COMPLETE_PROFILE_FORM',
  PROJECT_SUBMISSION: 'PROJECT_SUBMISSION',
  EVENT_SIGNUP_FORM: 'EVENT_SIGNUP_FORM',
  EVENT_JUDGING_FORM: 'EVENT_JUDGING_FORM',
  CMS_CREATE_EVENT_FORM: 'CMS_CREATE_EVENT_FORM',
  CMS_EDIT_EVENT_FORM: 'CMS_EDIT_EVENT_FORM',
  CMS_EMAIL_FORM: 'CMS_EMAIL_FORM',
  CMS_ADD_PARTICIPANTS_FORM: 'CMS_ADD_PARTICIPANTS_FORM',
  CMS_INVITE_PARTICIPANTS_FORM: 'CMS_INVITE_PARTICIPANTS_FORM',
  CMS_ADD_JUDGES_FORM: 'CMS_ADD_JUDGES_FORM',
  CMS_JUDGING_CRITERIA_FORM_CREATE: 'CMS_JUDGING_CRITERIA_FORM_CREATE',
  CMS_JUDGING_CRITERIA_FORM_EDIT: 'CMS_JUDGING_CRITERIA_FORM_EDIT',
  CMS_AWARD_FORM_CREATE: 'CMS_AWARD_FORM_CREATE',
  CMS_AWARD_FORM_EDIT: 'CMS_AWARD_FORM_EDIT',
  CMS_TICKET_FORM_CREATE: 'CMS_TICKET_FORM_CREATE',
  CMS_TICKET_FORM_EDIT: 'CMS_TICKET_FORM_EDIT',
  CMS_ANNOUNCEMENT_FORM_CREATE: 'CMS_ANNOUNCEMENT_FORM_CREATE',
  CMS_ANNOUNCEMENT_FORM_EDIT: 'CMS_ANNOUNCEMENT_FORM_EDIT',
  CMS_SCREENING_FORM_EDIT: 'CMS_SCREENING_FORM_EDIT',
  CMS_CLONE_EVENT_FORM: 'CMS_CLONE_EVENT_FORM'
};



// WEBPACK FOOTER //
// ./src/components/forms/formConstant.js